import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import FooterEtapa from 'pages/FluxoProjetos/Components/footerEtapa/footerEtapa';
import TitleEtapa from 'pages/FluxoProjetos/Components/titleEtapa/titleEtapa';
import { useContext, useLayoutEffect } from 'react';
import FotosVideos from '../campos/fotosVideos';
import IndiceFormativo from '../campos/indiceFormativo';
import IndiceInicial from '../campos/indiceInicial';
import styles from './etapas.scss';
const { rootClassName } = styles;

const etapa = EtapaProjeto.indices;
export default function Indices() {
  const { dispatch } = useContext(ProjetosContext);

  useLayoutEffect(() => {
    dispatch({ type: 'setEtapa', payload: etapa });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={rootClassName}>
      <TitleEtapa etapa={etapa} />
      <div className={`${rootClassName}-scrollable`}>
        <IndiceInicial />
        <IndiceFormativo />
        <FotosVideos etapa={etapa} />
      </div>
      <FooterEtapa etapa={etapa} />
    </div>
  );
}
